import { ROUTE } from "../../routes";
import SharedPropsService from "../../SharedPropsService";
export const GoToLoginAction = async (action, _datastore, { navigate }) => {
    await SharedPropsService.setOnboarding(true);
    navigate(ROUTE.PHONE_NUMBER, {});
};
